(function () {
    "use strict";

    const PERSONALIZATION_SELECTOR = '[data-af-module="personalization"]';
    const OPTION_SELECTOR =
        '.single-option-selector[data-option="option2"]';

    function getPanel() {
        return document.querySelector(PERSONALIZATION_SELECTOR);
    }

    function getOptionValue() {

        const select = document.querySelector(OPTION_SELECTOR);

        if (select) {
            return select.value.trim().toLowerCase();
        }

        // fallback cho swatch
        const activeValue = document.querySelector("#option-select-value-1");

        if (activeValue) {
            return activeValue.textContent.trim().toLowerCase();
        }

        return "";
    }

    function updatePersonalization() {

        const panel = getPanel();

        if (!panel) return;

        const value = getOptionValue();

        const show =
            value !== "no embroidery";

        panel.style.display = show ? "" : "none";

        // Nếu muốn bỏ dữ liệu khi ẩn
        if (!show) {

            panel.querySelectorAll("input, textarea, select")
                .forEach(function (field) {

                    if (
                        field.type === "checkbox" ||
                        field.type === "radio"
                    ) {
                        field.checked = false;
                    } else {
                        field.value = "";
                    }

                });

        }

    }

    function bindEvents() {

        document.addEventListener("change", function (e) {

            if (
                e.target.matches(OPTION_SELECTOR) ||
                e.target.matches('input[name="option-1"]')
            ) {

                requestAnimationFrame(updatePersonalization);

            }

        });

        document.addEventListener("click", function (e) {

            if (
                e.target.closest(".swatch-element")
            ) {

                setTimeout(updatePersonalization, 30);

            }

        });

        // Một số theme Shopify phát ra sự kiện này
        document.addEventListener("variant:change", function () {

            updatePersonalization();

        });

    }

    function init() {

        updatePersonalization();

        bindEvents();

    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }

})();